<div class="timepicker-backdrop" (click)="toggleSelector($event)" *ngIf="showSelector"></div>
<div class="form-control" [ngClass]="{'not-width-global': isWidth }">
  <label *ngIf="label" [attr.for]="id" class="control-label">{{ label }}</label>
  <div id="enter-time" class="control-input" [ngClass]="{disabled: disabled, 'not-width-global': isWidth }" (click)="!showSelector && toggleSelector($event)">
    <div class="input-icon" (click)="toggleSelector($event)">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM11 10H15V12H9V5H11V10Z" fill="#ACACAC"/>
      </svg>
    </div>
    <div id="input-enter-time" class="input-time" (click)="toggleSelector($event)" [ngClass]="{placeholder: !value && placeholder}">{{ value ? value : placeholder }}</div>
    <a class="icon" (click)="clearInput()" *ngIf="showClearBtn && value && !disabled">
      <img src="../../../../assets/svgs/i_closed.svg" alt="Limpar">
    </a>
    <div class="input-select" *ngIf="showSelector">
      <div class="select-header">
        <span *ngIf="!innerValue.hour || !innerValue.min">Horário</span>
        <span *ngIf="innerValue.hour && innerValue.min">{{ innerValue.hour }}:{{ innerValue.min }}</span>
      </div>
      <div class="select-columns">
        <div class="select-hour">
          <div class="hour-option" [ngClass]="{'selected': innerValue.hour === hour}" (click)="hourSelect(hourIdx)" *ngFor="let hour of hourOpts; let hourIdx = index">
            <span>{{ hour }}</span>
          </div>
        </div>
        <div class="select-minute">
          <div class="minute-option" [ngClass]="{'selected': innerValue.min === min}" (click)="minuteSelect(minIdx, $event)" *ngFor="let min of minuteOpts; let minIdx = index">
            <span>{{ min }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
